import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage, onValueChangeEvent } from '@scisys-uim/uim-common';
import { AssetsUser, BUSINESS_UNIT_EMAIL_CONTACT_METADATA, BUSINESS_UNIT_EMAIL_CONTACT_TYPE, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, BusinessUnitEmailContact, COST_CENTRE_METADATA, COST_CENTRE_TYPE, CostCentre, RANGER_SOURCE_MAP_METADATA, RANGER_SOURCE_MAP_TYPE, RANGER_TYPE, Ranger, RangerSourceMap, RefCode } from 'assets-model';
import { BusinessUnitEmailContactService, BusinessUnitService, CostCentreService, RangerDataSource, RangerService, RangerSourceMapService, RefCodeStorage } from 'assets-service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Directive()
export abstract class RangerSearchComponentBase extends CrudListComponent<Ranger, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'rangerId', 'businessUnit.buId', 'costCentre.ccId', 'policeContact.businessUnitEmailContactId', 'rangerSource.rangerSourceMapId', 'addr1', 'addr2', 'addr3', 'addressChangeNotifiedOn', 'addressChangedDate', 'county', 'createdBy', 'createdDate', 'currentFirearmCount', 'currentPersonalFirearmCount', 'email', 'firearmsAuthorityExpiryDate', 'firearmsAuthorityIssueDate', 'lockVersion', 'mobilePhone', 'name', 'national', 'postcode', 'provisionalRanger', 'status', 'town', 'updatedBy', 'updatedDate', 'volunteerRanger', 'wildlifeManagerRanger', 'actions'];

  public searchForm: FormGroup;

  rangerIdFilter: number;
  @ViewChild('rangerIdFilterInput') rangerIdFilterInput: ElementRef;

  businessUnitFilter: BusinessUnit;
  businessUnitSelectionList: BusinessUnit[];
  @ViewChild('businessUnitFilterInput') businessUnitFilterInput: MatSelect;

  costCentreFilter: CostCentre;
  costCentreSelectionList: CostCentre[];
  @ViewChild('costCentreFilterInput') costCentreFilterInput: MatSelect;

  policeContactFilter: BusinessUnitEmailContact;
  policeContactSelectionList: BusinessUnitEmailContact[];
  @ViewChild('policeContactFilterInput') policeContactFilterInput: MatSelect;

  rangerSourceFilter: RangerSourceMap;
  private rangerSourceSelectionListSubject: Subject<RangerSourceMap[]> = new BehaviorSubject([]);
  rangerSourceSelectionList: Observable<RangerSourceMap[]> = this.rangerSourceSelectionListSubject.asObservable();
  rangerSourceDefaultDebounceMillis: number = 500;
  @ViewChild('rangerSourceFilterInput') rangerSourceFilterInput: ElementRef;

  addr1Filter: string;
  @ViewChild('addr1FilterInput') addr1FilterInput: ElementRef;

  addr2Filter: string;
  @ViewChild('addr2FilterInput') addr2FilterInput: ElementRef;

  addr3Filter: string;
  @ViewChild('addr3FilterInput') addr3FilterInput: ElementRef;

  addressChangeNotifiedOnFilter: Date;
  @ViewChild('addressChangeNotifiedOnFilterInput') addressChangeNotifiedOnFilterInput: ElementRef;
  addressChangeNotifiedOnLessThanFilter: Date;
  @ViewChild('addressChangeNotifiedOnLessThanFilterInput') addressChangeNotifiedOnLessThanFilterInput: ElementRef;
  addressChangeNotifiedOnLessThanOrEqualToFilter: Date;
  @ViewChild('addressChangeNotifiedOnLessThanOrEqualToFilterInput') addressChangeNotifiedOnLessThanOrEqualToFilterInput: ElementRef;
  addressChangeNotifiedOnGreaterThanFilter: Date;
  @ViewChild('addressChangeNotifiedOnGreaterThanFilterInput') addressChangeNotifiedOnGreaterThanFilterInput: ElementRef;
  addressChangeNotifiedOnGreaterThanOrEqualToFilter: Date;
  @ViewChild('addressChangeNotifiedOnGreaterThanOrEqualToFilterInput') addressChangeNotifiedOnGreaterThanOrEqualToFilterInput: ElementRef;

  addressChangedDateFilter: Date;
  @ViewChild('addressChangedDateFilterInput') addressChangedDateFilterInput: ElementRef;
  addressChangedDateLessThanFilter: Date;
  @ViewChild('addressChangedDateLessThanFilterInput') addressChangedDateLessThanFilterInput: ElementRef;
  addressChangedDateLessThanOrEqualToFilter: Date;
  @ViewChild('addressChangedDateLessThanOrEqualToFilterInput') addressChangedDateLessThanOrEqualToFilterInput: ElementRef;
  addressChangedDateGreaterThanFilter: Date;
  @ViewChild('addressChangedDateGreaterThanFilterInput') addressChangedDateGreaterThanFilterInput: ElementRef;
  addressChangedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('addressChangedDateGreaterThanOrEqualToFilterInput') addressChangedDateGreaterThanOrEqualToFilterInput: ElementRef;

  countyFilter: string;
  @ViewChild('countyFilterInput') countyFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  currentFirearmCountFilter: number;
  @ViewChild('currentFirearmCountFilterInput') currentFirearmCountFilterInput: ElementRef;
  currentFirearmCountLessThanFilter: number;
  @ViewChild('currentFirearmCountLessThanFilterInput') currentFirearmCountLessThanFilterInput: ElementRef;
  currentFirearmCountLessThanOrEqualToFilter: number;
  @ViewChild('currentFirearmCountLessThanOrEqualToFilterInput') currentFirearmCountLessThanOrEqualToFilterInput: ElementRef;
  currentFirearmCountGreaterThanFilter: number;
  @ViewChild('currentFirearmCountGreaterThanFilterInput') currentFirearmCountGreaterThanFilterInput: ElementRef;
  currentFirearmCountGreaterThanOrEqualToFilter: number;
  @ViewChild('currentFirearmCountGreaterThanOrEqualToFilterInput') currentFirearmCountGreaterThanOrEqualToFilterInput: ElementRef;

  currentPersonalFirearmCountFilter: number;
  @ViewChild('currentPersonalFirearmCountFilterInput') currentPersonalFirearmCountFilterInput: ElementRef;
  currentPersonalFirearmCountLessThanFilter: number;
  @ViewChild('currentPersonalFirearmCountLessThanFilterInput') currentPersonalFirearmCountLessThanFilterInput: ElementRef;
  currentPersonalFirearmCountLessThanOrEqualToFilter: number;
  @ViewChild('currentPersonalFirearmCountLessThanOrEqualToFilterInput') currentPersonalFirearmCountLessThanOrEqualToFilterInput: ElementRef;
  currentPersonalFirearmCountGreaterThanFilter: number;
  @ViewChild('currentPersonalFirearmCountGreaterThanFilterInput') currentPersonalFirearmCountGreaterThanFilterInput: ElementRef;
  currentPersonalFirearmCountGreaterThanOrEqualToFilter: number;
  @ViewChild('currentPersonalFirearmCountGreaterThanOrEqualToFilterInput') currentPersonalFirearmCountGreaterThanOrEqualToFilterInput: ElementRef;

  emailFilter: string;
  @ViewChild('emailFilterInput') emailFilterInput: ElementRef;

  firearmsAuthorityIssueDateFilter: Date;
  @ViewChild('firearmsAuthorityIssueDateFilterInput') firearmsAuthorityIssueDateFilterInput: ElementRef;
  firearmsAuthorityIssueDateLessThanFilter: Date;
  @ViewChild('firearmsAuthorityIssueDateLessThanFilterInput') firearmsAuthorityIssueDateLessThanFilterInput: ElementRef;
  firearmsAuthorityIssueDateLessThanOrEqualToFilter: Date;
  @ViewChild('firearmsAuthorityIssueDateLessThanOrEqualToFilterInput') firearmsAuthorityIssueDateLessThanOrEqualToFilterInput: ElementRef;
  firearmsAuthorityIssueDateGreaterThanFilter: Date;
  @ViewChild('firearmsAuthorityIssueDateGreaterThanFilterInput') firearmsAuthorityIssueDateGreaterThanFilterInput: ElementRef;
  firearmsAuthorityIssueDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('firearmsAuthorityIssueDateGreaterThanOrEqualToFilterInput') firearmsAuthorityIssueDateGreaterThanOrEqualToFilterInput: ElementRef;

  mobilePhoneFilter: string;
  @ViewChild('mobilePhoneFilterInput') mobilePhoneFilterInput: ElementRef;

  nameFilter: string;
  @ViewChild('nameFilterInput') nameFilterInput: ElementRef;

  postcodeFilter: string;
  @ViewChild('postcodeFilterInput') postcodeFilterInput: ElementRef;

  provisionalRangerFilter: boolean;
  @ViewChild('provisionalRangerFilterInput') provisionalRangerFilterInput: MatSelect;

  statusSelectionList: RefCode[];
  statusFilter: string;
  @ViewChild('statusFilterInput') statusFilterInput: MatSelect;

  townFilter: string;
  @ViewChild('townFilterInput') townFilterInput: ElementRef;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;

  volunteerRangerFilter: boolean;
  @ViewChild('volunteerRangerFilterInput') volunteerRangerFilterInput: MatSelect;

  wildlifeManagerRangerFilter: boolean;
  @ViewChild('wildlifeManagerRangerFilterInput') wildlifeManagerRangerFilterInput: MatSelect;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected rangerService: RangerService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected policeContactService: BusinessUnitEmailContactService,
    protected rangerSourceService: RangerSourceMapService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(RANGER_TYPE, route, router, userStorage, dialog, rangerService, injector);

    this.searchForm = this.fb.group({
      rangerId: [null],
      businessUnit: [null],
      costCentre: [null],
      policeContact: [null],
      rangerSource: [null],
      addr1: [null],
      addr2: [null],
      addr3: [null],
      addressChangeNotifiedOnLessThan: [null],
      addressChangeNotifiedOnLessThanOrEqualTo: [null],
      addressChangeNotifiedOnGreaterThan: [null],
      addressChangeNotifiedOnGreaterThanOrEqualTo: [null],
      addressChangeNotifiedOn: [null],
      addressChangedDateLessThan: [null],
      addressChangedDateLessThanOrEqualTo: [null],
      addressChangedDateGreaterThan: [null],
      addressChangedDateGreaterThanOrEqualTo: [null],
      addressChangedDate: [null],
      county: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      currentFirearmCountLessThan: [null],
      currentFirearmCountLessThanOrEqualTo: [null],
      currentFirearmCountGreaterThan: [null],
      currentFirearmCountGreaterThanOrEqualTo: [null],
      currentFirearmCount: [null],
      currentPersonalFirearmCountLessThan: [null],
      currentPersonalFirearmCountLessThanOrEqualTo: [null],
      currentPersonalFirearmCountGreaterThan: [null],
      currentPersonalFirearmCountGreaterThanOrEqualTo: [null],
      currentPersonalFirearmCount: [null],
      email: [null],
      firearmsAuthorityIssueDateLessThan: [null],
      firearmsAuthorityIssueDateLessThanOrEqualTo: [null],
      firearmsAuthorityIssueDateGreaterThan: [null],
      firearmsAuthorityIssueDateGreaterThanOrEqualTo: [null],
      firearmsAuthorityIssueDate: [null],
      mobilePhone: [null],
      name: [null],
      postcode: [null],
      provisionalRanger: [null],
      status: [null],
      town: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null],
      volunteerRanger: [null],
      wildlifeManagerRanger: [null]
    });
  }

  createDataSource(): CrudDataSource<Ranger> {
    return new RangerDataSource(this.rangerService);
  }

  createServiceArguments(): any {
    return {
      rangerId: this.rangerIdFilter,
      buId: this.businessUnitFilter && this.businessUnitFilter.buId,
      ccId: this.costCentreFilter && this.costCentreFilter.ccId,
      businessUnitEmailContactId: this.policeContactFilter && this.policeContactFilter.businessUnitEmailContactId,
      rangerSourceMapId: this.rangerSourceFilter && this.rangerSourceFilter.rangerSourceMapId,
      addr1: this.addr1Filter,
      addr2: this.addr2Filter,
      addr3: this.addr3Filter,
      addressChangeNotifiedOnLessThan: this.addressChangeNotifiedOnLessThanFilter,
      addressChangeNotifiedOnLessThanOrEqualTo: this.addressChangeNotifiedOnLessThanOrEqualToFilter,
      addressChangeNotifiedOnGreaterThan: this.addressChangeNotifiedOnGreaterThanFilter,
      addressChangeNotifiedOnGreaterThanOrEqualTo: this.addressChangeNotifiedOnGreaterThanOrEqualToFilter,
      addressChangeNotifiedOn: this.addressChangeNotifiedOnFilter,
      addressChangedDateLessThan: this.addressChangedDateLessThanFilter,
      addressChangedDateLessThanOrEqualTo: this.addressChangedDateLessThanOrEqualToFilter,
      addressChangedDateGreaterThan: this.addressChangedDateGreaterThanFilter,
      addressChangedDateGreaterThanOrEqualTo: this.addressChangedDateGreaterThanOrEqualToFilter,
      addressChangedDate: this.addressChangedDateFilter,
      county: this.countyFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      currentFirearmCountLessThan: this.currentFirearmCountLessThanFilter,
      currentFirearmCountLessThanOrEqualTo: this.currentFirearmCountLessThanOrEqualToFilter,
      currentFirearmCountGreaterThan: this.currentFirearmCountGreaterThanFilter,
      currentFirearmCountGreaterThanOrEqualTo: this.currentFirearmCountGreaterThanOrEqualToFilter,
      currentFirearmCount: this.currentFirearmCountFilter,
      currentPersonalFirearmCountLessThan: this.currentPersonalFirearmCountLessThanFilter,
      currentPersonalFirearmCountLessThanOrEqualTo: this.currentPersonalFirearmCountLessThanOrEqualToFilter,
      currentPersonalFirearmCountGreaterThan: this.currentPersonalFirearmCountGreaterThanFilter,
      currentPersonalFirearmCountGreaterThanOrEqualTo: this.currentPersonalFirearmCountGreaterThanOrEqualToFilter,
      currentPersonalFirearmCount: this.currentPersonalFirearmCountFilter,
      email: this.emailFilter,
      firearmsAuthorityIssueDateLessThan: this.firearmsAuthorityIssueDateLessThanFilter,
      firearmsAuthorityIssueDateLessThanOrEqualTo: this.firearmsAuthorityIssueDateLessThanOrEqualToFilter,
      firearmsAuthorityIssueDateGreaterThan: this.firearmsAuthorityIssueDateGreaterThanFilter,
      firearmsAuthorityIssueDateGreaterThanOrEqualTo: this.firearmsAuthorityIssueDateGreaterThanOrEqualToFilter,
      firearmsAuthorityIssueDate: this.firearmsAuthorityIssueDateFilter,
      mobilePhone: this.mobilePhoneFilter,
      name: this.nameFilter,
      postcode: this.postcodeFilter,
      provisionalRanger: this.provisionalRangerFilter,
      status: this.statusFilter,
      town: this.townFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter,
      volunteerRanger: this.volunteerRangerFilter,
      wildlifeManagerRanger: this.wildlifeManagerRangerFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.rangerIdFilter = null;
    this.businessUnitFilter = null;
    this.costCentreFilter = null;
    this.policeContactFilter = null;
    this.rangerSourceFilter = null;
    this.addr1Filter = null;
    this.addr2Filter = null;
    this.addr3Filter = null;
    this.addressChangeNotifiedOnLessThanFilter = null;
    this.addressChangeNotifiedOnLessThanOrEqualToFilter = null;
    this.addressChangeNotifiedOnGreaterThanFilter = null;
    this.addressChangeNotifiedOnGreaterThanOrEqualToFilter = null;
    this.addressChangeNotifiedOnFilter = null;
    this.addressChangedDateLessThanFilter = null;
    this.addressChangedDateLessThanOrEqualToFilter = null;
    this.addressChangedDateGreaterThanFilter = null;
    this.addressChangedDateGreaterThanOrEqualToFilter = null;
    this.addressChangedDateFilter = null;
    this.countyFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.currentFirearmCountLessThanFilter = null;
    this.currentFirearmCountLessThanOrEqualToFilter = null;
    this.currentFirearmCountGreaterThanFilter = null;
    this.currentFirearmCountGreaterThanOrEqualToFilter = null;
    this.currentFirearmCountFilter = null;
    this.currentPersonalFirearmCountLessThanFilter = null;
    this.currentPersonalFirearmCountLessThanOrEqualToFilter = null;
    this.currentPersonalFirearmCountGreaterThanFilter = null;
    this.currentPersonalFirearmCountGreaterThanOrEqualToFilter = null;
    this.currentPersonalFirearmCountFilter = null;
    this.emailFilter = null;
    this.firearmsAuthorityIssueDateLessThanFilter = null;
    this.firearmsAuthorityIssueDateLessThanOrEqualToFilter = null;
    this.firearmsAuthorityIssueDateGreaterThanFilter = null;
    this.firearmsAuthorityIssueDateGreaterThanOrEqualToFilter = null;
    this.firearmsAuthorityIssueDateFilter = null;
    this.mobilePhoneFilter = null;
    this.nameFilter = null;
    this.postcodeFilter = null;
    this.provisionalRangerFilter = null;
    this.statusFilter = null;
    this.townFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
    this.volunteerRangerFilter = null;
    this.wildlifeManagerRangerFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.rangerIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.businessUnitFilterInput);
    this.addSearchOnChangedSelectEventListener(this.costCentreFilterInput);
    this.addSearchOnChangedSelectEventListener(this.policeContactFilterInput);
    this.wireRangerSourceAutocomplete();
    this.addSearchOnChangedInputEventListener(this.addr1FilterInput);
    this.addSearchOnChangedInputEventListener(this.addr2FilterInput);
    this.addSearchOnChangedInputEventListener(this.addr3FilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangeNotifiedOnLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangeNotifiedOnLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangeNotifiedOnGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangeNotifiedOnGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangeNotifiedOnFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.addressChangedDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.countyFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentFirearmCountLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentFirearmCountLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentFirearmCountGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentFirearmCountGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentFirearmCountFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentPersonalFirearmCountLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentPersonalFirearmCountLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentPersonalFirearmCountGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentPersonalFirearmCountGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.currentPersonalFirearmCountFilterInput);
    this.addSearchOnChangedInputEventListener(this.emailFilterInput);
    this.addSearchOnChangedInputEventListener(this.firearmsAuthorityIssueDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.firearmsAuthorityIssueDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.firearmsAuthorityIssueDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.firearmsAuthorityIssueDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.firearmsAuthorityIssueDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.mobilePhoneFilterInput);
    this.addSearchOnChangedInputEventListener(this.nameFilterInput);
    this.addSearchOnChangedInputEventListener(this.postcodeFilterInput);
    this.addSearchOnChangedSelectEventListener(this.provisionalRangerFilterInput);
    this.addSearchOnChangedSelectEventListener(this.statusFilterInput);
    this.addSearchOnChangedInputEventListener(this.townFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.volunteerRangerFilterInput);
    this.addSearchOnChangedSelectEventListener(this.wildlifeManagerRangerFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      rangerId: (value: number) => self.rangerIdFilter = value,
      businessUnit: (value: BusinessUnit) => { self.businessUnitFilter = value; this.businessUnitChanged(value, false); },
      costCentre: (value: CostCentre) => { self.costCentreFilter = value; this.costCentreChanged(value, false); },
      policeContact: (value: BusinessUnitEmailContact) => { self.policeContactFilter = value; this.policeContactChanged(value, false); },
      rangerSource: (value: RangerSourceMap) => { self.rangerSourceFilter = value; this.rangerSourceChanged(value, false); },
      addr1: (value: string) => self.addr1Filter = value,
      addr2: (value: string) => self.addr2Filter = value,
      addr3: (value: string) => self.addr3Filter = value,
      addressChangeNotifiedOnLessThan: (value: Date) => self.addressChangeNotifiedOnLessThanFilter = value,
      addressChangeNotifiedOnLessThanOrEqualTo: (value: Date) => self.addressChangeNotifiedOnLessThanOrEqualToFilter = value,
      addressChangeNotifiedOnGreaterThan: (value: Date) => self.addressChangeNotifiedOnGreaterThanFilter = value,
      addressChangeNotifiedOnGreaterThanOrEqualTo: (value: Date) => self.addressChangeNotifiedOnGreaterThanOrEqualToFilter = value,
      addressChangeNotifiedOn: (value: Date) => self.addressChangeNotifiedOnFilter = value,
      addressChangedDateLessThan: (value: Date) => self.addressChangedDateLessThanFilter = value,
      addressChangedDateLessThanOrEqualTo: (value: Date) => self.addressChangedDateLessThanOrEqualToFilter = value,
      addressChangedDateGreaterThan: (value: Date) => self.addressChangedDateGreaterThanFilter = value,
      addressChangedDateGreaterThanOrEqualTo: (value: Date) => self.addressChangedDateGreaterThanOrEqualToFilter = value,
      addressChangedDate: (value: Date) => self.addressChangedDateFilter = value,
      county: (value: string) => self.countyFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      currentFirearmCountLessThan: (value: number) => self.currentFirearmCountLessThanFilter = value,
      currentFirearmCountLessThanOrEqualTo: (value: number) => self.currentFirearmCountLessThanOrEqualToFilter = value,
      currentFirearmCountGreaterThan: (value: number) => self.currentFirearmCountGreaterThanFilter = value,
      currentFirearmCountGreaterThanOrEqualTo: (value: number) => self.currentFirearmCountGreaterThanOrEqualToFilter = value,
      currentFirearmCount: (value: number) => self.currentFirearmCountFilter = value,
      currentPersonalFirearmCountLessThan: (value: number) => self.currentPersonalFirearmCountLessThanFilter = value,
      currentPersonalFirearmCountLessThanOrEqualTo: (value: number) => self.currentPersonalFirearmCountLessThanOrEqualToFilter = value,
      currentPersonalFirearmCountGreaterThan: (value: number) => self.currentPersonalFirearmCountGreaterThanFilter = value,
      currentPersonalFirearmCountGreaterThanOrEqualTo: (value: number) => self.currentPersonalFirearmCountGreaterThanOrEqualToFilter = value,
      currentPersonalFirearmCount: (value: number) => self.currentPersonalFirearmCountFilter = value,
      email: (value: string) => self.emailFilter = value,
      firearmsAuthorityIssueDateLessThan: (value: Date) => self.firearmsAuthorityIssueDateLessThanFilter = value,
      firearmsAuthorityIssueDateLessThanOrEqualTo: (value: Date) => self.firearmsAuthorityIssueDateLessThanOrEqualToFilter = value,
      firearmsAuthorityIssueDateGreaterThan: (value: Date) => self.firearmsAuthorityIssueDateGreaterThanFilter = value,
      firearmsAuthorityIssueDateGreaterThanOrEqualTo: (value: Date) => self.firearmsAuthorityIssueDateGreaterThanOrEqualToFilter = value,
      firearmsAuthorityIssueDate: (value: Date) => self.firearmsAuthorityIssueDateFilter = value,
      mobilePhone: (value: string) => self.mobilePhoneFilter = value,
      name: (value: string) => self.nameFilter = value,
      postcode: (value: string) => self.postcodeFilter = value,
      provisionalRanger: (value: boolean) => self.provisionalRangerFilter = value,
      status: (value: string) => self.statusFilter = value,
      town: (value: string) => self.townFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value,
      volunteerRanger: (value: boolean) => self.volunteerRangerFilter = value,
      wildlifeManagerRanger: (value: boolean) => self.wildlifeManagerRangerFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  wireRangerSourceAutocomplete(): void {
    if (this.rangerSourceFilterInput) {
      onValueChangeEvent(this.rangerSource, value => {
        if (value == "") {
          value = null;
          this.rangerSourceFilter = null;
        }
        if (value == null || typeof value == 'string') {
          this.rangerSourceSelectionListFilter(value);
        }
        if (value == null || typeof value != 'string') {
          this.maybeDoAutoSearch();
        }
      }, {
        debounceMillis: this.getRangerSourceLookupDebounceTime()
      });
    }
  }
  
  rangerIdChanging(value: number, unsetDependents: boolean = true) {}
  
  rangerIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) {}
  
  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  

  costCentreLoadSelectionList() {
    this.costCentreService.findAll().subscribe(
      data => {
        this.costCentreSelectionList = data.items;
      }
    );
  }
  
  costCentreDisplay(item: CostCentre) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return COST_CENTRE_TYPE.description(item);
  }
  
  costCentreChanging(value: CostCentre, unsetDependents: boolean = true) {}
  
  costCentreChanged(value: CostCentre, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  costCentreCompare(a: any, b: any) {
    return COST_CENTRE_METADATA.equals(a, b);
  }
  
  

  policeContactLoadSelectionList() {
    this.policeContactService.findAll().subscribe(
      data => {
        this.policeContactSelectionList = data.items;
      }
    );
  }
  
  policeContactDisplay(item: BusinessUnitEmailContact) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_EMAIL_CONTACT_TYPE.description(item);
  }
  
  policeContactChanging(value: BusinessUnitEmailContact, unsetDependents: boolean = true) {}
  
  policeContactChanged(value: BusinessUnitEmailContact, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  policeContactCompare(a: any, b: any) {
    return BUSINESS_UNIT_EMAIL_CONTACT_METADATA.equals(a, b);
  }
  
  

  getRangerSourceLookupDebounceTime(): number {
    if (this.systemConfig?.rangerSourceMap?.lookup?.debounceTime != null) {
      return this.systemConfig.rangerSourceMap.lookup.debounceTime;
    }
    return this.rangerSourceDefaultDebounceMillis;
  }
  
  getRangerSourceLookupMinCharacters(): number {
    if (this.systemConfig?.rangerSourceMap?.lookup?.minCharacters != null) {
      return this.systemConfig.rangerSourceMap.lookup.minCharacters;
    }
    return 2;
  }

  rangerSourceSelectionListFilter(text: string) {
    if (text == null || text.length < this.getRangerSourceLookupMinCharacters()) {
      this.rangerSourceSelectionListSubject.next([]);
      return;
    }
    this.rangerSourceSelectionListFilterLoad(text).subscribe(items => {
      this.rangerSourceSelectionListSubject.next(items);
    });
  }

  abstract rangerSourceSelectionListFilterLoad(text: string): Observable<RangerSourceMap[]>;
  
  rangerSourceDisplay(item: RangerSourceMap) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return RANGER_SOURCE_MAP_TYPE.description(item);
  }
  
  rangerSourceChanging(value: RangerSourceMap, unsetDependents: boolean = true) {}
  
  rangerSourceChanged(value: RangerSourceMap, unsetDependents: boolean = true) {
    this.triggerSearch();
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  rangerSourceCompare(a: any, b: any) {
    return RANGER_SOURCE_MAP_METADATA.equals(a, b);
  }
  
  

  addr1Changing(value: string, unsetDependents: boolean = true) {}
  
  addr1Changed(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addr2Changing(value: string, unsetDependents: boolean = true) {}
  
  addr2Changed(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addr3Changing(value: string, unsetDependents: boolean = true) {}
  
  addr3Changed(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangeNotifiedOnChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangeNotifiedOnChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangeNotifiedOnLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangeNotifiedOnLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangeNotifiedOnLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangeNotifiedOnLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangeNotifiedOnGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangeNotifiedOnGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangeNotifiedOnGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangeNotifiedOnGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  addressChangedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  addressChangedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  countyChanging(value: string, unsetDependents: boolean = true) {}
  
  countyChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentFirearmCountChanging(value: number, unsetDependents: boolean = true) {}
  
  currentFirearmCountChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentFirearmCountLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  currentFirearmCountLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentFirearmCountLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  currentFirearmCountLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentFirearmCountGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  currentFirearmCountGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentFirearmCountGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  currentFirearmCountGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentPersonalFirearmCountChanging(value: number, unsetDependents: boolean = true) {}
  
  currentPersonalFirearmCountChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentPersonalFirearmCountLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  currentPersonalFirearmCountLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentPersonalFirearmCountLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  currentPersonalFirearmCountLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentPersonalFirearmCountGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  currentPersonalFirearmCountGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  currentPersonalFirearmCountGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  currentPersonalFirearmCountGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  emailChanging(value: string, unsetDependents: boolean = true) {}
  
  emailChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmsAuthorityIssueDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  firearmsAuthorityIssueDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmsAuthorityIssueDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  firearmsAuthorityIssueDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmsAuthorityIssueDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  firearmsAuthorityIssueDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmsAuthorityIssueDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  firearmsAuthorityIssueDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  firearmsAuthorityIssueDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  firearmsAuthorityIssueDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  mobilePhoneChanging(value: string, unsetDependents: boolean = true) {}
  
  mobilePhoneChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nameChanging(value: string, unsetDependents: boolean = true) {}
  
  nameChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  postcodeChanging(value: string, unsetDependents: boolean = true) {}
  
  postcodeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  provisionalRangerChanging(value: boolean, unsetDependents: boolean = true) {}
  
  provisionalRangerChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  statusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RANGER_STATUS').subscribe(
      data => {
        this.statusSelectionList = data;
      }
    );
  }

  statusChanging(value: string, unsetDependents: boolean = true) {}
  
  statusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  townChanging(value: string, unsetDependents: boolean = true) {}
  
  townChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  volunteerRangerChanging(value: boolean, unsetDependents: boolean = true) {}
  
  volunteerRangerChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  wildlifeManagerRangerChanging(value: boolean, unsetDependents: boolean = true) {}
  
  wildlifeManagerRangerChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get rangerId() {
    return this.searchForm && this.searchForm.get('rangerId');
  }

  get businessUnit() {
    return this.searchForm && this.searchForm.get('businessUnit');
  }

  get costCentre() {
    return this.searchForm && this.searchForm.get('costCentre');
  }

  get policeContact() {
    return this.searchForm && this.searchForm.get('policeContact');
  }

  get rangerSource() {
    return this.searchForm && this.searchForm.get('rangerSource');
  }

  get addr1() {
    return this.searchForm && this.searchForm.get('addr1');
  }

  get addr2() {
    return this.searchForm && this.searchForm.get('addr2');
  }

  get addr3() {
    return this.searchForm && this.searchForm.get('addr3');
  }

  get addressChangeNotifiedOn() {
    return this.searchForm && this.searchForm.get('addressChangeNotifiedOn');
  }

  get addressChangeNotifiedOnLessThan() {
    return this.searchForm && this.searchForm.get('addressChangeNotifiedOnLessThan');
  }
  
  get addressChangeNotifiedOnLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('addressChangeNotifiedOnLessThanOrEqualTo');
  }
  
  get addressChangeNotifiedOnGreaterThan() {
    return this.searchForm && this.searchForm.get('addressChangeNotifiedOnGreaterThan');
  }
  
  get addressChangeNotifiedOnGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('addressChangeNotifiedOnGreaterThanOrEqualTo');
  }

  get addressChangedDate() {
    return this.searchForm && this.searchForm.get('addressChangedDate');
  }

  get addressChangedDateLessThan() {
    return this.searchForm && this.searchForm.get('addressChangedDateLessThan');
  }
  
  get addressChangedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('addressChangedDateLessThanOrEqualTo');
  }
  
  get addressChangedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('addressChangedDateGreaterThan');
  }
  
  get addressChangedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('addressChangedDateGreaterThanOrEqualTo');
  }

  get county() {
    return this.searchForm && this.searchForm.get('county');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get currentFirearmCount() {
    return this.searchForm && this.searchForm.get('currentFirearmCount');
  }

  get currentFirearmCountLessThan() {
    return this.searchForm && this.searchForm.get('currentFirearmCountLessThan');
  }
  
  get currentFirearmCountLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('currentFirearmCountLessThanOrEqualTo');
  }
  
  get currentFirearmCountGreaterThan() {
    return this.searchForm && this.searchForm.get('currentFirearmCountGreaterThan');
  }
  
  get currentFirearmCountGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('currentFirearmCountGreaterThanOrEqualTo');
  }

  get currentPersonalFirearmCount() {
    return this.searchForm && this.searchForm.get('currentPersonalFirearmCount');
  }

  get currentPersonalFirearmCountLessThan() {
    return this.searchForm && this.searchForm.get('currentPersonalFirearmCountLessThan');
  }
  
  get currentPersonalFirearmCountLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('currentPersonalFirearmCountLessThanOrEqualTo');
  }
  
  get currentPersonalFirearmCountGreaterThan() {
    return this.searchForm && this.searchForm.get('currentPersonalFirearmCountGreaterThan');
  }
  
  get currentPersonalFirearmCountGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('currentPersonalFirearmCountGreaterThanOrEqualTo');
  }

  get email() {
    return this.searchForm && this.searchForm.get('email');
  }

  get firearmsAuthorityIssueDate() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityIssueDate');
  }

  get firearmsAuthorityIssueDateLessThan() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityIssueDateLessThan');
  }
  
  get firearmsAuthorityIssueDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityIssueDateLessThanOrEqualTo');
  }
  
  get firearmsAuthorityIssueDateGreaterThan() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityIssueDateGreaterThan');
  }
  
  get firearmsAuthorityIssueDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityIssueDateGreaterThanOrEqualTo');
  }

  get mobilePhone() {
    return this.searchForm && this.searchForm.get('mobilePhone');
  }

  get name() {
    return this.searchForm && this.searchForm.get('name');
  }

  get postcode() {
    return this.searchForm && this.searchForm.get('postcode');
  }

  get provisionalRanger() {
    return this.searchForm && this.searchForm.get('provisionalRanger');
  }

  get status() {
    return this.searchForm && this.searchForm.get('status');
  }

  get town() {
    return this.searchForm && this.searchForm.get('town');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }

  get volunteerRanger() {
    return this.searchForm && this.searchForm.get('volunteerRanger');
  }

  get wildlifeManagerRanger() {
    return this.searchForm && this.searchForm.get('wildlifeManagerRanger');
  }


}



